import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE_ORIGIN } from "@/lib/api";

/**
 * One-tap WhatsApp share button for campaigns.
 * Opens wa.me with a prefilled, empathetic message + campaign link.
 */
export const WhatsAppShare = ({ title, path, compact = false, className = "" }) => {
  const url = `${SITE_ORIGIN}${path}`;
  const message = `\u{1F49A} ${title} \u2014 Citizen Awareness Foundation\n\nEvery share brings us closer to change. See how you can help:\n${url}`;
  const href = `https://wa.me/?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`whatsapp-share-${path.split("/").pop()}`}
      aria-label={`Share ${title} on WhatsApp`}
      className={`inline-flex items-center gap-1.5 rounded-full border border-[hsl(var(--green)/0.35)] bg-[hsl(var(--green)/0.10)] text-[hsl(var(--green))] hover:bg-[hsl(var(--green)/0.18)] font-semibold transition-colors focus-ring ${compact ? "h-8 px-3 text-xs" : "h-9 px-4 text-sm"} ${className}`}
    >
      <MessageCircle className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
      Share
    </a>
  );
};
